module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap6"
    }
  }, [_vm._v("The Tale of Old Venn")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The chain of deconstructions cannot, of course, be contained here: for if the image functions as a violent displacement from the origin, life, or meaning to which it apparently refers, there is a second fundamental question raised more or less explicitly in each of these essays. What about my text as the image of the image: what about the possibility of reading …?")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CAROL JACOBS")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("The Dissimulating Harmony")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f58bd160","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/OPS/12-chap6.vue
// module id = 105
// module chunks = 0